import { apiClient } from './index';

export interface AICredential {
  provider: string;
  last4: string;
  model?: string;
}

export interface AICredentialStatus {
  configured: boolean;
  credential?: AICredential;
}

export async function getAICredential(): Promise<AICredentialStatus> {
  const { data } = await apiClient.get<AICredentialStatus>('/ai/credentials');
  return data;
}

export async function setAICredential(key: string, model?: string): Promise<void> {
  await apiClient.put('/ai/credentials', { key, model });
}

export async function deleteAICredential(): Promise<void> {
  await apiClient.delete('/ai/credentials');
}

/** Why AI calls cannot run for this workspace ('' when they can). */
export type AIUnavailableReason = '' | 'disabled' | 'not_configured' | 'quota_exceeded';

export interface AIStatus {
  available: boolean;
  reason: AIUnavailableReason;
}

/** GET /ai/status — any workspace member; mirrors the server's AI preflight. */
export async function getAIStatus(): Promise<AIStatus> {
  const { data } = await apiClient.get<AIStatus>('/ai/status');
  return data;
}
